import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
export function usePageVisibility() {
  const $ = _c(4);
  const [isPageVisible, setIsPageVisible] = useState(true);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const handleVisibilityChange = () => {
        setIsPageVisible(!document.hidden);
      };
      document.addEventListener("visibilitychange", handleVisibilityChange);
      return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== isPageVisible) {
    t2 = {
      isPageVisible
    };
    $[2] = isPageVisible;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}